const TOKEN = "TOKEN";
const USER_DATA = "USER_DATA";
const ONBOARDING_USERID = "onBoardingKey";

export const saveToken = (token) => {
  try {
    localStorage.setItem(TOKEN, token);
  } catch (error) {
    console.log("Error while saving token : ", error);
  }
};

export const getToken = () => {
  try {
    const value = localStorage.getItem(TOKEN);
    if (value !== null) {
      return value;
    }
  } catch (e) {
    console.log("Error while Get token : ", e);
  }
};

export const saveUserPref = async (data) => {
  try {
    localStorage.setItem(USER_DATA, JSON.stringify(data));
    // console.log('[UserPrefs.js] save User prefs :',data)
  } catch (error) {
    console.log("Error while saving user : ", error);
  }
};

export const getUserPref = () => {
  try {
    const value = localStorage.getItem(USER_DATA);
    if (value !== null) {
      return value;
    }
  } catch (e) {
    console.log("Error while Get User : ", e);
  }
};

export const clearUserPrefs = async () => {
  try {
    //  localStorage.clear()
    localStorage.removeItem(USER_DATA);
    localStorage.removeItem(TOKEN);
    localStorage.removeItem(ONBOARDING_USERID);
  } catch (e) {
    console.log("[user Prefs] Clear Prefs Error", e);
  }
  console.log("[user Prefs] Clear Prefs Done");
};

export const firstLoginOnboaringView = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
    // console.log('[UserPrefs.js] save User prefs :',data)
  } catch (error) {
    console.log("Error while saving user : ", error);
  }
};

export const getfirstLoginOnboaringView = (key) => {
  try {
    const value = localStorage.getItem(key);
    if (value !== null) {
      return value;
    }
  } catch (e) {
    console.log("Error while Get User : ", e);
  }
};
